import { PageRoutes } from '@/constants/PageRoutes.ts'
import { FullScreenMinHeight } from 'ui-components'
import { useI18n, I18nT } from 'i18n-utils'
import { useUserInfoStore } from 'store'
import './LoginPrompt.scss'

export default defineComponent({
  name: 'LoginPrompt',
  setup(_, { slots }) {
    const router = useRouter()
    const { t } = useI18n()
    const userInfoStore = useUserInfoStore()

    const onRegister = () => {
      router.push({
        path: PageRoutes.Register,
        query: {
          entry: 'login',
        }
      })
    }

    const onLogin = () => {
      router.push({ path: PageRoutes.Login })
    }

    return () => (
      <>
        {!userInfoStore.isLogin ? (
          <FullScreenMinHeight>
            <div class="login-prompt-layout">
              <I18nT keypath="{login} 或 {register}进行交易">
                {{
                  login: () => (
                    <span class={'btn cursor-pointer'} onClick={onLogin}>
                      {t('登录')}
                    </span>
                  ),
                  register: () => (
                    <span class={'btn cursor-pointer'} onClick={onRegister}>
                      {t('立即注册')}
                    </span>
                  ),
                }}
              </I18nT>
            </div>
          </FullScreenMinHeight>
        ) : (
          <>{slots.default?.()}</>
        )}
      </>
    )
  },
})
